import { GAME_ID, INIT_SEQUENCE } from '../foodTruckConstants';

const initialState = {
  sequence: null,
  sequenceId: null,
  userInitiated: false,
};

const foodTruckAudioSequenceReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case INIT_SEQUENCE: {
      return {
        ...initialState,
        sequence: action.payload.sequence,
        sequenceId: action.payload.sequence ? action.payload.sequence.id : null,
        userInitiated: action.payload.userInitiated,
      };
    }
    default:
      return state;
  }
};

export default foodTruckAudioSequenceReducer;
